import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './GiftConfirmation.module.scss';
import { monthDayYear } from '@alltrails/shared/utils/timeHelpers';

type Props = {
  recipientName: string;
  recipientEmail: string;
  sendDate: Date;
};

const GiftConfirmation = ({ recipientName, recipientEmail, sendDate }: Props) => {
  const languageRegionCode = useLanguageRegionCode();

  const formattedDate = monthDayYear(sendDate, languageRegionCode);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FormattedMessage defaultMessage="Please confirm recipient details" />
      </div>
      <div className={styles.label}>
        <FormattedMessage defaultMessage="To:" /> <span>{recipientName}</span>
      </div>
      <div className={styles.label}>
        <FormattedMessage defaultMessage="Email:" /> <span>{recipientEmail}</span>
      </div>
      <div className={styles.label}>
        <FormattedMessage defaultMessage="Send date:" /> <span>{formattedDate}</span>
      </div>
    </div>
  );
};

export default GiftConfirmation;
